export default {
  VERIFY_HOMEOWNER_CONTACT: "[homeowner] POST Homeowner Contact",
  // INSERTION_PT (for script, do not remove)
};
